export default [
  {
    path: '/salaryManage/prepay/approval/:orderNo',
    component: () => import('@/views/salaryManage/prepay/approval'),
    name: 'OutsourcingPrepayApproval',
    meta: { title: '核准预支结算单', icon: 'a-up', noCache: true },
    hidden: true
  },
  {
    path: '/salaryManage/prepay/payment/:orderNo',
    component: () => import('@/views/salaryManage/prepay/payment'),
    name: 'prepaySettPayment',
    meta: { title: '预支工资结算', icon: 'a-up', noCache: true },
    hidden: true
  },
  {
    path: '/salaryManage/prepay/record',
    component: () => import('@/views/salaryManage/prepay/repayPlan.vue'),
    name: 'repayPlan',
    meta: { title: '还款计划', icon: 'a-up', noCache: false },
    hidden: true
  },

  {
    path: '/salaryManage/payroll/importBatch/',
    component: () => import('@/views/salaryManage/payroll/approval/importBatch'),
    name: 'OutsourcingPayrollApprovalImportBatch',
    meta: { title: '工资单导入', icon: 'a-up', noCache: false },
    hidden: true
  },
  {
    path: '/salaryManage/payroll/approval/:billNo',
    component: () => import('@/views/salaryManage/payroll/approval'),
    name: 'OutsourcingPayrollApproval',
    meta: { title: '核准工资单', icon: 'a-up', noCache: false },
    hidden: true
  },
]
